<template>
  <div>
    <ContentHeader :show-back="false" />
    <div class="content-container">
      <el-row>
        <el-col :span="6">
          <el-card shadow="hover" class="cursor">
            <router-link to="/freezer/list">
              <div class="card-icon">
                <i class="iconfont iconzu141 icon-1" />
              </div>
              <div class="card-text">浏览资产管理</div>
            </router-link>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="cursor">
            <router-link to="/freezer/apply">
              <div class="card-icon">
                <i class="iconfont iconzu141 icon-2" />
              </div>
              <div class="card-text">领用资产管理</div>
            </router-link>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="never" class="card-disabled" title="敬请期待">
            <div class="card-icon">
              <i class="iconfont iconzu141 icon-3" />
            </div>
            <div class="card-text">跟踪资产管理</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="never" class="card-disabled" title="敬请期待">
            <div class="card-icon">
              <i class="iconfont iconzu141 icon-4" />
            </div>
            <div class="card-text">资产管理指南</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  .el-col {
    padding: 0 $content-middle;
    .el-card {
      height: 280px;
      text-align: center;
      .card-icon {
        padding: 70px 0 4px 0;
        margin-bottom: $content-middle;
        .iconfont {
          font-size: 44px;
          font-weight: bold;
          transition: all 0.4s;
        }
      }
      .card-text {
        font-size: $font-16;
      }
    }
  }
}
.icon-1 {
  color: $base-red
}
.icon-2 {
  color: $base-yellow
}
</style>
